import React from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

export default function Footer({ reserved, image }) {
  return (
    <footer className={styles.footermain}>
      <hr />
      <div className="container">
        <div className={styles.footerRow}>
        <form
            className={styles.donateForm}
            action="https://www.paypal.com/donate"
            method="post"
            target="_top"
          >
            <input type="hidden" name="hosted_button_id" value="7SGU24U9N2K5Q" />
            <input
              type="image"
              src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif"
              border="0"
              name="submit"
              title="PayPal - The safer, easier way to pay online!"
              alt="Donate with PayPal button"
            />
            <img
              alt=""
              border="0"
              src="https://www.paypal.com/en_US/i/scr/pixel.gif"
              width="1"
              height="1"
            />
          </form>
          <p className={styles.copyright}>{reserved}</p>
    
          <Link to="/" className={styles.logoLink}>
            <img
              src={image}
              width="50px"
              alt="logo"
              style={{ borderRadius: "10px" }}
            />
          </Link>
        </div>
      </div>
    </footer>
  );
}
